class CartItem {

    constructor(item, amount) {
        this.item = item;
        this.amount = amount;
        this.enableSurgeCharge = item.enableSurgeCharge !== undefined ? item.enableSurgeCharge : true;
        this.id = item.id;
    }

}

export { CartItem as default }
